interface ISearchBarInputProps {
  placeholderText?: string;
  ariaLabel?: string;
  searchInput: string;
  setSearchInput: (value: string) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
}



const SearchBarInput = ({placeholderText, ariaLabel, searchInput, setSearchInput, handleKeyDown}: ISearchBarInputProps) => {

    return (
        <input
            id="thrive-component-search-bar-input"
            className="thrive-component-search-bar-input"
            type="text"
            placeholder={placeholderText}
            autoComplete="off"
            aria-label={ariaLabel}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={handleKeyDown}
        />
    );
};

export default SearchBarInput;